import { CommonService } from 'src/app/services/common/common.service';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentService } from 'src/app/services/document/document.service';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { GlobalService } from 'src/app/services/global/global.service';
import { AppService } from 'src/app/services/app/app.service';

@Component({
  selector: 'app-view-folder',
  templateUrl: './view-folder.component.html',
  styleUrls: ['./view-folder.component.scss']
})
export class ViewFolderComponent {
  public empCourseData:any='';
  public data:any='';
  public empId:any;
  public isSpinnerLoading:boolean=false;
  public isBackAvailable:boolean=false;
  public isNoRecordFound:boolean=false;
  public imageURL:string=GlobalService.imageURL
  constructor(private commonService : CommonService, private docService:DocumentService, @Inject(MAT_DIALOG_DATA) public dialogData:any,private spinner:NgxSpinnerService,
  private dialog: MatDialog, private appService:AppService){}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    if(this.dialogData && this.dialogData.folder_id){
      this.getEmpCourseWork(this.dialogData.folder_id,this.dialogData.e_id)
    }
  }
  getEmpCourseWork(f_id,e_id){
    this.isNoRecordFound=false;
    this.spinner.show()
    this.docService.getEmpCourseWork(f_id, e_id).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success.status == 200) {
          this.data = success.data;
          this.empCourseData = success.data.listing;
          this.isBackAvailable = false;
          if (
            this.empCourseData.folder.length == 0 &&
            this.empCourseData.files.length == 0
          ) {
            this.isNoRecordFound = true;
          }
          if (success.data["parent_folder"]["parent_folder_id"] != 0) {
            this.isBackAvailable = true;
          }
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onBack(){
    this.getEmpCourseWork(this.data["parent_folder"]["parent_folder_id"],this.dialogData.e_id)
  }
  onDeleteItem(id){
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: 'course_document', id: id }
    },));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        // this.onDocType(this.docType)   
        this.getEmpCourseWork(this.dialogData.folder_id,this.dialogData.e_id)
      }
    });
  }
  onFileDownload(data: string){
    if (data.includes("https")) {
      this.appService.downloadFile(data,'course-document')
    }
    else {
      this.appService.downloadFile(this.imageURL + data, 'course')
    }
  }
  onCancel(){
    
  }
}
